import React from 'react';
import PropTypes from 'prop-types';
import { MemoryPhotoV1 } from '../MemoryPhotoV1';
import { MemorySymbolV1 } from '../MemorySymbolV1';
import { BLOCKS, CARDS } from '../../shared/memory-map-data';
import { CHAPTER_DONE_IMAGES } from '../../shared/memory-map-assets';
import { SIGNS, SIGN_VALUES, getMemoryMap } from '../../shared/memory-map-helpers';
import styles from './PauseSlideContentV31.css';

const CHAPTERS_COUNT = BLOCKS.length;
const SYMBOL_SIZE = 80;

function PauseSlideContentV31({ blockIndex, results }) {
    const chapter = getMemoryMap(results.userResponses).ch[blockIndex];
    const card = CARDS[blockIndex];
    const sign = SIGNS[blockIndex];

    return (
        <section className={styles.form}>
            <div className={styles.card}>
                <p className={styles.eyebrow}>{`${BLOCKS[blockIndex].chapter} of ${CHAPTERS_COUNT}`}</p>
                <div className={styles.row}>
                    <div className={styles.titleBlock}>
                        <h1 className={styles.heading}>{card.title}</h1>
                        <p className={styles.count}>{card.line(chapter.count)}</p>
                    </div>
                    <div className={styles.symbol}>
                        <MemorySymbolV1 type={sign} value={SIGN_VALUES[sign][chapter.state - 1]} size={SYMBOL_SIZE} />
                    </div>
                </div>
                <p className={styles.verdict}>{card[chapter.level]}</p>
            </div>
            <MemoryPhotoV1 imageId={CHAPTER_DONE_IMAGES[blockIndex]} radius='small' />
            <p className={styles.fact}>{card.fact}</p>
        </section>
    );
}

PauseSlideContentV31.propTypes = {
    blockIndex: PropTypes.number.isRequired,
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired
};

export {
    PauseSlideContentV31
};
